<a href="javascript: void(0)">
    <i class="fas fa-lg fa-plus-square p-r-half" aria-hidden="true"></i>
    <ng-content></ng-content>
</a>
